import { useState, type FormEvent } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { authClient } from '../../services/authClient'
import { ApiClientError } from '../../services/apiClient'
import { useAuth } from '../../auth/AuthContext'
import { AuthShell } from './LoginPage'

export function EmailEntryPage() {
  const { state } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (state.status === 'authenticated') {
    return <Navigate to={state.user.audience === 'admin' ? '/admin' : '/dashboard'} replace />
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await authClient.registerInitiate(email)
      navigate('/verify-otp', { state: { email, purpose: 'signup' as const }, replace: true })
    } catch (err) {
      if (err instanceof ApiClientError) {
        setError(err.apiError.message)
      } else {
        setError('No se pudo enviar el código. Verifica tu conexión.')
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthShell title="Crear cuenta" subtitle="Ingresa tu correo para comenzar">
      <form onSubmit={handleSubmit} className="auth-form" noValidate>
        <label className="field">
          <span>Correo electrónico</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            autoFocus
            disabled={submitting}
          />
        </label>

        {error && <p className="error">{error}</p>}

        <button type="submit" className="primary-btn" disabled={submitting || !email.trim()}>
          {submitting ? 'Enviando código…' : 'Continuar'}
        </button>

        <div className="auth-links">
          <Link to="/login">¿Ya tienes cuenta? Inicia sesión</Link>
        </div>
      </form>
    </AuthShell>
  )
}
